import { useState } from 'react';
import { T, useTheme, Ico } from '../../../design';

export interface PhoneInputProps {
  value: string;
  onChange: (value: string) => void;
  ariaLabel: string;
  placeholder?: string;
  onEnter?: () => void;
  autoFocus?: boolean;
}

export function PhoneInput({ value, onChange, ariaLabel, placeholder = 'Mobilnummer', onEnter, autoFocus }: PhoneInputProps) {
  const t = useTheme();
  const [f, setF] = useState(false);
  return (
    <div style={{ display: 'flex', gap: 8 }}>
      <div aria-hidden style={{ display: 'flex', alignItems: 'center', gap: 5, height: 48, padding: '0 12px', borderRadius: t.radius, border: `1.5px solid ${T.border}`, background: T.tertiary, color: T.fg2, fontSize: 14, fontWeight: 700, flexShrink: 0 }}>
        <span role="img" aria-label="DK">🇩🇰</span> +45
      </div>
      <div style={{ flex: 1, minWidth: 0, display: 'flex', alignItems: 'center', gap: 9, height: 48, padding: '0 14px', background: T.surface, border: `1.5px solid ${f ? t.accent : T.border}`, borderRadius: t.radius, boxShadow: f ? `0 0 0 3px ${t.accent}1a` : 'none', transition: 'all 150ms' }}>
        <Ico.phone size={17} style={{ color: f ? t.accent : T.fg3, flexShrink: 0 }} />
        <input
          aria-label={ariaLabel}
          value={value}
          onChange={(e) => onChange(e.target.value.replace(/[^\d ]/g, ''))}
          onKeyDown={(e) => { if (e.key === 'Enter' && onEnter) onEnter(); }}
          onFocus={() => setF(true)}
          onBlur={() => setF(false)}
          placeholder={placeholder}
          inputMode="tel"
          autoFocus={autoFocus}
          style={{ flex: 1, minWidth: 0, border: 0, outline: 0, background: 'transparent', fontSize: 16, fontFamily: T.font, fontWeight: 600, color: T.fg, letterSpacing: '0.02em' }}
        />
      </div>
    </div>
  );
}
